import React from 'react';
import './Services.css';

const Services = () => {
  // SSS verisi hem ekranda göstermek hem JSON-LD oluşturmak için
  const faq = [
    {
      q: 'Yerinde servisiniz var mı?',
      a: 'Mersin merkezi ve çevre ilçelerde yerinde arıza tespiti ve onarım hizmeti veriyoruz.'
    },
    {
      q: 'Hangi markalara servis veriyorsunuz?',
      a: 'Canon, HP, Epson, Xerox, Ricoh, Kyocera ve diğer yaygın markalara teknik servis sağlıyoruz.'
    },
    {
      q: 'Kiralama sözleşmeleri ne içerir?',
      a: 'Düzenli bakım, arıza desteği ve sarf malzeme tedariği sözleşme kapsamına dahildir.'
    }
  ];

  // JSON-LD oluşturma
  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq.map(item => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a
      }
    }))
  };

  return (
    <section className="services" id="services">
      <div className="services-content">
        <h2>Hizmetlerimiz</h2>
        <div className="service-list">
          <div className="service-item">
            <h3>Fotokopi ve Yazıcı Tamiri</h3>
            <p>Mersin genelinde Canon, HP, Epson gibi tüm markalara teknik servis hizmeti sunuyoruz.</p>
          </div>
          <div className="service-item">
            <h3>Fotokopi ve Yazıcı Kiralama</h3>
            <p>Kurumsal firmalara uzun veya kısa süreli yazıcı ve fotokopi kiralama çözümleri.</p>
          </div>
          <div className="service-item">
            <h3>Toner Dolumu ve Satışı</h3>
            <p>Orijinal ve muadil toner satışı ve dolum hizmeti. Aynı gün teslimat imkanı.</p>
          </div>
          <div className="service-item">
            <h3>Periyodik Bakım ve Onarım</h3>
            <p>Makinalarınızın performansını artırmak için düzenli bakım hizmeti sunuyoruz.</p>
          </div>
        </div>

        {/* Görünür SSS bölümü */}
        <div className="faq-section">
          <h2>Sıkça Sorulan Sorular</h2>
          {faq.map((item, index) => (
            <div key={index} className="faq-item">
              <h3>{item.q}</h3>
              <p>{item.a}</p>
            </div>
          ))}
        </div>

        {/* JSON-LD şema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
        />
      </div>
    </section>
  );
};

export default Services;
